import {
  Calculator, BookOpen, FlaskConical, Globe2, Landmark, Languages, Laptop,
  Palette, Music, HeartPulse, Briefcase, Leaf, Sprout, Dumbbell, Atom, Scale,
} from "lucide-react";

const PALETTE = ["#0B1B3F", "#2A4F9E", "#D9950F", "#1D3A7A", "#3D67C2", "#13285A", "#A8730A", "#2F5FB3"];

const ICON_RULES = [
  [/math/i, Calculator],
  [/english|literature|language|yoruba|igbo|hausa|french/i, Languages],
  [/science|physics|chemistry|biology/i, FlaskConical],
  [/technology|computer|ict|digital/i, Laptop],
  [/social|civic|history|government/i, Landmark],
  [/geograph/i, Globe2],
  [/agric/i, Sprout],
  [/art|creative|culture/i, Palette],
  [/music/i, Music],
  [/health|physical|home/i, HeartPulse],
  [/business|commerce|account/i, Briefcase],
  [/religio|christian|islamic/i, Scale],
  [/environment|climate/i, Leaf],
  [/sport/i, Dumbbell],
];

function hash(str) {
  let h = 0;
  for (let i = 0; i < str.length; i++) h = (h * 31 + str.charCodeAt(i)) >>> 0;
  return h;
}

export function subjectStyle(name = "") {
  const rule = ICON_RULES.find(([re]) => re.test(name));
  return { Icon: rule ? rule[1] : name ? BookOpen : Atom, color: PALETTE[hash(name) % PALETTE.length] };
}

export function errMsg(err, fallback = "Something went wrong. Please try again.") {
  const d = err?.response?.data?.detail;
  if (typeof d === "string" && d) return d;
  if (err?.response?.status === 429) return "You are going a little fast. Please wait a moment and try again.";
  return fallback;
}

export function classQuery(cls) {
  return cls ? `?class=${encodeURIComponent(cls)}` : "";
}

export function readingMinutes(lesson) {
  if (!lesson) return 1;
  const parts = [lesson.intro];
  const blocks = lesson.parts?.length ? lesson.parts : [lesson];
  blocks.forEach((b) => {
    parts.push(b.try_it, ...(b.key_points || []));
    (b.sections || []).forEach((s) => {
      parts.push(s.heading, s.body);
      if (s.example) parts.push(s.example.title, s.example.body);
    });
  });
  const words = parts.filter(Boolean).join(" ").split(/\s+/).filter(Boolean).length;
  return Math.max(1, Math.round(words / 150));
}

export const LETTERS = ["A", "B", "C", "D", "E", "F"];
